module.exports = __webpack_public_path__ + "static/img/album_4.13b34ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/album_4.png
// module id = ewT3
// module chunks = 1